var heading_default = {
  "fontElementMap": "Me0EK",
  "elementSpacing": "eFeBO",
  "headerOne": "_34qjS eFeBO",
  "headerTwo": "BhNF3 eFeBO",
  "headerThree": "dGNmp eFeBO",
  "headerFour": "DoWVg eFeBO",
  "headerFive": "renkv eFeBO",
  "headerSix": "M2XBZ eFeBO",
  "child": "fPX46"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
